var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../../assets/imgs/customer-service.png"),"width":"100%","alt":""}}),_c('van-cell',{attrs:{"title":"电话客服","is-link":""},on:{"click":_vm.contact}},[_c('b',{staticClass:"place-text"},[_vm._v("工作日9:00～18:00")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }